<template>
<ItpUsercontrol
  :loading="loading"
  :reloading="reloading"
  :loaded="loaded"
  :error="error"
  @reload="evh_7315092382398562_reload($event, {})"
>
  <FieldsetContractGeneralData
    :contract="contract"
    :labelAlign="labelAlign"
    v-if="!target || target === 'general'"
  >
  </FieldsetContractGeneralData>
  <hr
    v-if="!target"
  >
  </hr>
  <FieldsetContractNumbersData
    :contract="contract"
    :labelAlign="labelAlign"
    v-if="!target || target === 'general'"
  >
  </FieldsetContractNumbersData>
  <hr
    v-if="!target"
  >
  </hr>
  <FieldsetContractCompanyData
    :contract="contract"
    :labelAlign="labelAlign"
    v-if="!target || target === 'company'"
  >
  </FieldsetContractCompanyData>
  <hr
    v-if="!target"
  >
  </hr>
  <FieldsetContractClientData
    :contract="contract"
    :labelAlign="labelAlign"
    v-if="!target || target === 'counterparty'"
  >
  </FieldsetContractClientData>
  <hr
    v-if="!target"
  >
  </hr>
  <FieldsetContractRentalData
    :contract="contract"
    :labelAlign="labelAlign"
    v-if="!target || target === 'rental'"
  >
  </FieldsetContractRentalData>
  <hr
    v-if="!target"
  >
  </hr>
  <FieldsetContractLifecycle
    :contract="contract"
    :labelAlign="labelAlign"
    v-if="!target || target === 'lifecycle'"
  >
  </FieldsetContractLifecycle>
  <hr
    v-if="!target"
  >
  </hr>
  <FieldsetContractInvoicing
    :contract="contract"
    :labelAlign="labelAlign"
    v-if="!target || target === 'invoicing'"
  >
  </FieldsetContractInvoicing>
</ItpUsercontrol>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class ContractEditorFieldset extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  @Prop({
    required: true,
    type: Object,
  })
  contract!: object;

  @Watch('contract')
  onContract(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("contract")
  }

  @Prop({
    type: String,
  })
  target!: string;

  @Watch('target')
  onTarget(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("target")
  }

  labelAlign!: any;
  ux!: any;
  dataMembers = ['labelAlign', 'ux'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        labelAlign: "right",
        ux: null,
      },
    }
  }

  async evh_7315092382398562_reload(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_reload.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_reloadComponentData_3742: actions.ReloadComponentDataAction;
    evh_7315092382398562_reload_3741: actions.EventHandlerImpl;
    evh_7315092382398562_reload: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_reloadComponentData_3742 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_7315092382398562_reload_3741 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_reloadComponentData_3742,
        event: "reload",
        displayName: "reloadComponentData",
      }
    );
    const evh_7315092382398562_reload = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_reload_3741],
      }
    );
    return {
      act_7315092382398562_reloadComponentData_3742,
      evh_7315092382398562_reload_3741,
      evh_7315092382398562_reload,
    }
  }
}

Vue.component("ContractEditorFieldset", ContractEditorFieldset);

</script>